import { authFetch } from '~/services/fetch'
import type { WorkScheduleLogSearchParams, WorkScheduleLogResponse } from '../interfaces'

export async function getWorkScheduleLogs(
  params: WorkScheduleLogSearchParams
): Promise<WorkScheduleLogResponse> {
  const { orders, ...otherParams } = params
  const response = await authFetch({
    url: '/work-schedule-log',
    method: 'POST',
    data: {
      ...otherParams,
      orders: orders ?? [{ field: 'created_at', sort: 'desc' }],
    },
  })
  return response.data
}
